import React, { createContext, useContext, useEffect, useState } from "react";
import apiService from "../services/apiService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [me, setMe] = useState(() => apiService.getAuthUser()); // from localStorage
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    const data = await apiService.getMe(); // ✅ cookie-based
    apiService.saveAuthUser(data);         // store for quick load
    setMe(data);
    return data;
  };

  useEffect(() => {
    const boot = async () => {
      try {
        await refreshMe(); // ✅ always fetch fresh user from cookie
      } catch (e) {
        apiService.clearAuthUser();
        setMe(null);
      } finally {
        setLoading(false);
      }
    };
    boot();
  }, []);

  const value = {
    me,
    loading,
    setMe,
    refreshMe,
    isLoggedIn: !!me,
    roleCode: me?.RoleCode || null,
    roleId: me?.RoleID || null,
    fullName: me?.FullName || null,
    username: me?.Username || null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
